var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelbeeLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.528,
    height: 62.41,
    viewBox: "0 0 173.528 62.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "welbee-logo-red",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M35.335,13.59H33.7a1.767,1.767,0,0,0-1.678,1.248L27.13,31.489,21.422,14.772a1.745,1.745,0,0,0-1.645-1.182H17.358A1.745,1.745,0,0,0,15.7,14.772L10.092,31.478,5.146,14.838A1.745,1.745,0,0,0,3.478,13.59H1.745a1.745,1.745,0,0,0-1.413.718,1.712,1.712,0,0,0-.243,1.557l7.078,21.8a1.734,1.734,0,0,0,1.667,1.2h2.286a1.745,1.745,0,0,0,1.656-1.193L18.3,20.867l6.228,16.861a1.745,1.745,0,0,0,1.634,1.1h2.208a1.745,1.745,0,0,0,1.656-1.2l6.968-21.764a1.745,1.745,0,0,0-.254-1.557A1.723,1.723,0,0,0,35.335,13.59Z",
    transform: "translate(0 1.417)",
    fill: "#eb5b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M58.361,16.531a10.633,10.633,0,0,0-3.832-2.617,13.074,13.074,0,0,0-4.859-.894,13.67,13.67,0,0,0-5.168.972A12.235,12.235,0,0,0,40.4,16.73a12.588,12.588,0,0,0-2.705,4.207,14.52,14.52,0,0,0-.961,5.311,14.951,14.951,0,0,0,.883,5.146,12.489,12.489,0,0,0,2.54,4.218,12.146,12.146,0,0,0,4.03,2.838,12.952,12.952,0,0,0,5.333,1.1A15.856,15.856,0,0,0,55.8,38.395a12.047,12.047,0,0,0,4.052-2.981,1.734,1.734,0,0,0-.232-2.54l-1.049-.817a1.734,1.734,0,0,0-2.33.177,9.574,9.574,0,0,1-2.44,1.745,9.43,9.43,0,0,1-4.284.883,7.122,7.122,0,0,1-5.2-2.208A8.425,8.425,0,0,1,42.7,30.279a9.142,9.142,0,0,1-.464-1.3.828.828,0,0,1,.144-.718.85.85,0,0,1,.685-.342H59.951a1.734,1.734,0,0,0,1.734-1.667,16.938,16.938,0,0,0-.85-5.521A11.661,11.661,0,0,0,58.361,16.531Zm-2.286,6.8a.839.839,0,0,1-.663.32H43.157a.872.872,0,0,1-.7-.353.828.828,0,0,1-.121-.729,7,7,0,0,1,2.01-3.147,7.442,7.442,0,0,1,5.168-1.756,6.945,6.945,0,0,1,5.013,1.745,6.206,6.206,0,0,1,1.723,3.224.806.806,0,0,1-.177.7Z",
    transform: "translate(3.828 1.357)",
    fill: "#eb5b41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 4.958,
    height: 40.281,
    rx: 1.58,
    transform: "translate(72.712 0.001)",
    fill: "#eb5b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M100.945,18.164a12.146,12.146,0,0,0-4.174-2.783,14.355,14.355,0,0,0-5.411-1,11.274,11.274,0,0,0-5.068,1.1A12.533,12.533,0,0,0,82.98,17.91V1.745A1.734,1.734,0,0,0,81.2,0h-1.48A1.745,1.745,0,0,0,78,1.745V38.537a1.745,1.745,0,0,0,1.734,1.745H81.2a1.734,1.734,0,0,0,1.734-1.745v-1.7a10.788,10.788,0,0,0,3.059,2.584,11.881,11.881,0,0,0,5.985,1.491,12.522,12.522,0,0,0,4.969-1,12.146,12.146,0,0,0,4.03-2.783,13.25,13.25,0,0,0,2.672-4.207,14.785,14.785,0,0,0,0-10.545A12.93,12.93,0,0,0,100.945,18.164Zm-1.59,9.441a10.015,10.015,0,0,1-.574,3.412,8.028,8.028,0,0,1-1.656,2.716A7.928,7.928,0,0,1,94.563,35.6a8.977,8.977,0,0,1-6.769,0,7.729,7.729,0,0,1-4.273-4.538,10.457,10.457,0,0,1,0-6.835,8.027,8.027,0,0,1,1.656-2.716,7.928,7.928,0,0,1,2.595-1.822,8.977,8.977,0,0,1,6.769,0,7.928,7.928,0,0,1,2.595,1.822,8.028,8.028,0,0,1,1.656,2.716,10.126,10.126,0,0,1,.563,3.379Z",
    transform: "translate(8.129 0.001)",
    fill: "#eb5b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M128.654,16.531a10.634,10.634,0,0,0-3.832-2.617,13.051,13.051,0,0,0-4.847-.894,13.725,13.725,0,0,0-5.179.972,12.146,12.146,0,0,0-6.8,6.945A14.356,14.356,0,0,0,107,26.248a14.951,14.951,0,0,0,.883,5.146,12.488,12.488,0,0,0,2.54,4.218,12.146,12.146,0,0,0,4.03,2.838,13.007,13.007,0,0,0,5.344,1.1,15.8,15.8,0,0,0,6.217-1.1,12.047,12.047,0,0,0,4.052-2.981,1.712,1.712,0,0,0,.442-1.3,1.8,1.8,0,0,0-.663-1.237l-1.1-.817a1.734,1.734,0,0,0-2.33.177,9.574,9.574,0,0,1-2.319,1.689,9.386,9.386,0,0,1-4.273.883,7.089,7.089,0,0,1-2.893-.585,7.266,7.266,0,0,1-2.319-1.6,8.171,8.171,0,0,1-1.6-2.374,8,8,0,0,1-.475-1.3.8.8,0,0,1,.155-.718.839.839,0,0,1,.685-.342h16.872a1.745,1.745,0,0,0,1.745-1.689,16.928,16.928,0,0,0-.861-5.521A11.506,11.506,0,0,0,128.654,16.531Zm-2.286,6.8a.806.806,0,0,1-.663.32H113.46a.872.872,0,0,1-.707-.353.828.828,0,0,1-.121-.729,7.1,7.1,0,0,1,2.01-3.147,7.464,7.464,0,0,1,5.179-1.756,6.912,6.912,0,0,1,5,1.745,6.205,6.205,0,0,1,1.723,3.224.806.806,0,0,1-.177.7Z",
    transform: "translate(11.151 1.357)",
    fill: "#eb5b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M140.889,27.979h16.872a1.745,1.745,0,0,0,1.745-1.734,16.642,16.642,0,0,0-.861-5.521,11.638,11.638,0,0,0-2.462-4.163,10.821,10.821,0,0,0-3.832-2.617,13.151,13.151,0,0,0-4.858-.894,13.626,13.626,0,0,0-5.168.972,12.08,12.08,0,0,0-6.813,6.945,14.354,14.354,0,0,0-.972,5.355,14.95,14.95,0,0,0,.883,5.146,12.587,12.587,0,0,0,2.54,4.218,12.146,12.146,0,0,0,4.03,2.838,13.007,13.007,0,0,0,5.344,1.1,15.8,15.8,0,0,0,6.217-1.1,12.047,12.047,0,0,0,4.052-2.981,1.712,1.712,0,0,0,.442-1.3A1.756,1.756,0,0,0,157.386,33l-1.1-.817a1.734,1.734,0,0,0-2.33.177,9.574,9.574,0,0,1-2.341,1.612,9.386,9.386,0,0,1-4.273.883,7.089,7.089,0,0,1-2.893-.585,7.266,7.266,0,0,1-2.319-1.6,8.17,8.17,0,0,1-1.557-2.33,8,8,0,0,1-.475-1.3.861.861,0,0,1,.839-1.1ZM153.9,23.33a.839.839,0,0,1-.674.32H140.978a.85.85,0,0,1-.7-.353.8.8,0,0,1-.132-.729,7.1,7.1,0,0,1,2.01-3.147,7.464,7.464,0,0,1,5.179-1.756,6.912,6.912,0,0,1,5,1.745,6.206,6.206,0,0,1,1.723,3.224.839.839,0,0,1-.166.7Z",
    transform: "translate(14.02 1.36)",
    fill: "#eb5b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M146.444,47.069s-.221-.166-.254-.2A2.943,2.943,0,0,1,146.444,47.069Z",
    transform: "translate(15.234 4.884)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M146.578,47.928l-.088-.088.177.265Z",
    transform: "translate(15.266 4.986)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M146.18,48.431c.431.276.1-.243.309-.221l.11.055L146.313,48C146.268,48.121,146.357,48.442,146.18,48.431Z",
    transform: "translate(15.233 5.002)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M145.23,48c.166.121.077.166.1,0h-.1Z",
    transform: "translate(15.134 5.002)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M145.286,47.933Z",
    transform: "translate(15.133 4.992)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M145.186,48.231l-.066-.221c-.1-.066-.166,0-.21-.11A.475.475,0,0,0,145.186,48.231Z",
    transform: "translate(15.101 4.992)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M145.353,48.488V48.41S145.276,48.377,145.353,48.488Z",
    transform: "translate(15.144 5.045)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M145.29,48.24v.188c.066,0,.188.155,0-.077C145.434,48.461,145.334,48.35,145.29,48.24Z",
    transform: "translate(15.141 5.027)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M145.38,48.266c.11,0,.21,0,.276.221C145.722,48.31,145.435,48.089,145.38,48.266Z",
    transform: "translate(15.15 5.023)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M146.523,48.736h.166l-.088-.166C146.645,48.7,146.4,48.636,146.523,48.736Z",
    transform: "translate(15.266 5.062)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M144.65,48.37l.32.287v-.132a.74.74,0,0,1-.32-.155Z",
    transform: "translate(15.074 5.041)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M144.94,48.63l.055.2C145.084,48.785,145.006,48.707,144.94,48.63Z",
    transform: "translate(15.104 5.068)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M145.726,48.886l-.166-.386.144.42Z",
    transform: "translate(15.169 5.055)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M144.413,48.6l-.132-.232.188.353Z",
    transform: "translate(15.035 5.041)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M144.289,48.783c-.1-.188-.265-.232-.309-.353a1.016,1.016,0,0,0,.1.4C144.068,48.728,144.124,48.706,144.289,48.783Z",
    transform: "translate(15.004 5.047)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M144.147,49.022a.63.63,0,0,0-.077-.232,1.379,1.379,0,0,0,.077.232Z",
    transform: "translate(15.013 5.085)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M144.865,48.9a.817.817,0,0,0-.265-.188l.232.21Z",
    transform: "translate(15.069 5.076)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M144.827,48.9Z",
    transform: "translate(15.084 5.096)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M144.85,48.87Z",
    transform: "translate(15.095 5.093)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M145.36,48.85c.077.166.11.386.375.486C145.625,49.159,145.47,49.1,145.36,48.85Z",
    transform: "translate(15.148 5.091)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M145.115,49.12h.133a1.1,1.1,0,0,1-.188-.21Z",
    transform: "translate(15.117 5.097)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M145.147,49.21l-.033-.11h-.044Z",
    transform: "translate(15.118 5.117)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M144.44,49.1a.2.2,0,0,1,0,.221.254.254,0,0,0,.21,0C144.572,49.2,144.473,49.046,144.44,49.1Z",
    transform: "translate(15.052 5.116)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M144.64,49Z",
    transform: "translate(15.073 5.107)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M144,49.61Z",
    transform: "translate(15.006 5.17)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M144.64,49.3c.077,0,.055,0,0-.144a.334.334,0,0,1,0,.11Z",
    transform: "translate(15.073 5.123)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M144.111,49.182l.166.088C144.2,49.2,144.077,49.116,144.111,49.182Z",
    transform: "translate(15.017 5.123)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M144.583,49h0C144.528,48.937,144.55,49,144.583,49Z",
    transform: "translate(15.063 5.104)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M144.58,49a.849.849,0,0,0,.077.188.583.583,0,0,0,0-.133Z",
    transform: "translate(15.067 5.107)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M145.011,51.306c-.155-.243-.21-.53.066-.364a4.659,4.659,0,0,0-1.027-1.292.662.662,0,0,1,.144.386c.121.11.409.144.486.409s-.155,0-.3-.088c.254.254.133.53.464.939v-.232C144.9,51.141,144.933,51.262,145.011,51.306Z",
    transform: "translate(15.011 5.174)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M144.242,49.57h0c-.066,0-.166-.066-.342-.21a.773.773,0,0,0,.121.331l.2-.1Z",
    transform: "translate(14.996 5.144)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M144.38,49.41c.166.254.166.431.42.651.1-.1-.088-.265-.1-.42-.121.188-.066-.166-.287-.21a.21.21,0,0,1,0-.132h-.177l.055.088c-.088,0-.055,0-.055-.088h0l-.066.254A.274.274,0,0,0,144.38,49.41Z",
    transform: "translate(15.024 5.138)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M146,49.8Z",
    transform: "translate(15.215 5.19)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M145.914,49.789s-.1-.144,0-.155.1.1.177.177-.066-.243-.254-.276h0a1.1,1.1,0,0,1-.5-.265A5.06,5.06,0,0,0,145.914,49.789Z",
    transform: "translate(15.146 5.135)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M145.14,49.64v.243l.243.144-.1-.121C145.35,49.883,145.206,49.75,145.14,49.64Z",
    transform: "translate(15.125 5.173)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M143.937,49.536l-.177-.276.188.431Z",
    transform: "translate(14.981 5.134)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M143.8,49.682l-.166-.232.055.166Z",
    transform: "translate(14.968 5.154)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M132.246,55.65l-.066.077Z",
    transform: "translate(13.774 5.8)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M132.641,55.7V55.57C132.63,55.636,132.619,55.7,132.641,55.7Z",
    transform: "translate(13.821 5.791)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M139.2,51.859c-.155-.232-.342-.6-.243-.3l.1.287C139.1,51.781,139.14,51.8,139.2,51.859Z",
    transform: "translate(14.477 5.362)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M135.8,54.149v0Z",
    transform: "translate(14.152 5.622)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M135.863,55.308l-.132-.188a.728.728,0,0,0,.133.188Z",
    transform: "translate(14.144 5.744)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M130.011,55.7l-.121.3C130.011,56.031,130.011,55.855,130.011,55.7Z",
    transform: "translate(13.536 5.805)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M142.022,50.83c-.121-.088-.188-.11-.232-.1C141.945,50.852,142.121,51.028,142.022,50.83Z",
    transform: "translate(14.776 5.287)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M132.565,52.69a.375.375,0,0,0-.055.188A.342.342,0,0,0,132.565,52.69Z",
    transform: "translate(13.809 5.491)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M141.651,50.826h0c0-.066,0-.121.11-.132C141.706,50.65,141.618,50.594,141.651,50.826Z",
    transform: "translate(14.761 5.279)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M122.451,52.71Z",
    transform: "translate(12.76 5.493)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M122.39,49.141a.11.11,0,0,1,.077,0Z",
    transform: "translate(12.754 5.121)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M143,50Z",
    transform: "translate(14.902 5.211)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M143.79,50.83l.066.133Z",
    transform: "translate(14.984 5.297)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M141.94,52.58Z",
    transform: "translate(14.792 5.48)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M143.159,50.08h-.1a.287.287,0,0,0,.1,0Z",
    transform: "translate(14.908 5.219)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M143.07,50h.055S143.081,49.9,143.07,50Z",
    transform: "translate(14.909 5.207)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M143,50.052a.088.088,0,0,1,.088,0h0S143,50,143,50.052Z",
    transform: "translate(14.902 5.214)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M126.646,53.87h0C126.557,53.947,126.579,53.936,126.646,53.87Z",
    transform: "translate(13.192 5.614)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M138.65,55Z",
    transform: "translate(14.449 5.732)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M138.52,55.3c0-.386.066-.353.144-.287l-.254-.861Z",
    transform: "translate(14.424 5.643)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M132.351,56.349l.11.287c-.221.442-.331.265-.232.674.11-.961.585,0,.685-1l.088.21h-.066c.155.475.188-.685.42-.53a.309.309,0,0,1,.066.331l.2-.232v.166l.287-.055h0a1.5,1.5,0,0,1,.2-.486c.066.144,0,.1,0,.221l.155-.232c.055.254-.077.5-.188.464.11.961.144-.243.442.331l-.155.11c.088.552.21.353.375.707,0-.188-.331-.872-.155-1.1,0,.066.11.1.21-.088,0,.342.088.265.2.243v.453c.121-.121.121-.353.188-.563.133,0,.166.4.2.7.221.066-.155-.563.1-.663.188.177.309,0,.519-.3.133.155,0,.287,0,.409l.1-.364v.177c.088-.144,0-.453.133-.585,0-.5.331.729.486.144v.453a2.484,2.484,0,0,0,.364-.806l.188.287a1.634,1.634,0,0,1,.077-1.1c-.055-.155-.1-.3-.133-.364l.188-.265a1.027,1.027,0,0,1,0,.431v-.121a1.247,1.247,0,0,1,0,.685l-.11-.265a4.419,4.419,0,0,0,0,.85.365.365,0,0,1,.055-.132,1.1,1.1,0,0,0,0,.188q0,.083,0-.166l.1.5v-.2a2.817,2.817,0,0,0,.331.287c.155-.541.243-1.314.53-1.557a5.179,5.179,0,0,0,.121,1.038c-.144-.453-.232.232-.42.166.1,0,.11.243.088.32l.265-.464c0,.364.1.265.2.4-.155-.7.166-.5.254-.729,0,.232.055.475-.11.442.254.508.1-.85.331-.431,0,0-.066,0,0,.1,0-.232.287-.1.276.11h0a.607.607,0,0,0,.674-.74c0,.077.11.718.121.85V53.434c.077.519.5,1.689.353,2.021.077.066.166.133.254-.077a2.275,2.275,0,0,1-.221-.773,3.665,3.665,0,0,0,.464.718c-.088-.1-.21-.905-.11-.905s.2.784.188.872v-.828a2.4,2.4,0,0,0,.265.861c-.055-.144.21,0,.254-.121l-.144-.155c.3,0,0-1.159.221-1.193a2.564,2.564,0,0,0,.364,1.1,11.418,11.418,0,0,1-.188-2.33l.11.21.077-.309a16.219,16.219,0,0,1,.155,2.484c.155.144.11.254.254.188a.287.287,0,0,1,0,.375h.4c-.166-.442.121-.53,0-.916-.066.21-.144.4-.221.6-.155-.464-.188-1.358.055-1.358a5.4,5.4,0,0,1,.287.972c0-.166.121-.375.188-.276v.276c.2.121,0-.674.32-.3.066,0,.386.519.3.243a14.552,14.552,0,0,1-.972-2.462,4.858,4.858,0,0,1,.607.629c.243.364.232.994.442,1.314a1.171,1.171,0,0,1,0-.353c.088.088.121.386.221.287-.155-.464.265-.066-.088-.409.066-.177.155,0,.287,0a2.694,2.694,0,0,1-.232-1.2,1.534,1.534,0,0,0,.177.309c.254,0,.475.1.685,0,.066.1.243.177.287.386v-.3c.32.309-.121.133.2.53-.11-.254,0-.431,0-.64-.232-.375-.254,0-.276.243a2.65,2.65,0,0,1-.287-1.546c.088-.21.243.309.232.221.375-.066-.232-1.1.221-.817a3.6,3.6,0,0,1,.541.883c-.066.21-.32-.088-.409,0l.2.088c0,.144,0,.276-.133.21.254.254.574-.254.983-.121a.487.487,0,0,0-.132-.409v.1c-.232-.232-.088-.453-.254-.519,0-.243-.088-.607.133-.541l.265.342c-.077-.1-.232-.155-.2,0,0-.2.53.364.287-.155l-.265-.2c0-.243-.177-.707,0-.663-.3-.32,0,.055-.364-.309.42.475-.3.166.177.651-.409-.442-.287-.121-.651-.475.077.121.177.21.055.21a.732.732,0,0,0,0,.121h0a1.1,1.1,0,0,1,.166.155c.132.32,0,.4,0,.585-.1,0-.066-.166-.177-.276v.265c-.177-.265-.431-.364-.386-.607h-.132c-.155-.11-.287-.121-.287,0-.088,0,0,.4,0,.144l-.1.287v-.066c-.21,0-.177.674-.663.265,0,.11,0,.232-.21.2l-.132-.243c0,.121-.375-.144-.3.144-.386-.651-.486,0-.7,0l.121.331c-.11,0-.177.155-.265.342l.11.3c0,.287-.386-.1-.563,0,0-.121,0-.11.088,0-.442-.6-.32.651-.7.21,0,.133-.066.11-.121,0h0l-.11-.144.1.144a.342.342,0,0,0-.121.177l-.121-.331h0c-.088-.11,0,.166.1.409a1.238,1.238,0,0,0,0,.221c-.2-.519-.122.221-.331-.331,0,.287-.254.287-.155.883v-.121c0-.011-.177-.1-.2.077l-.121-.42v.607a1.027,1.027,0,0,1-.21-.729c-.11.563-.132.232-.221.773v-.276c-.066,0-.11.409-.188.188-.254-.5-.773.077-1.248-.375.188.817-.232-.342-.155.3-.055-.2-.121-.3-.077-.475-.177.221-.331-.276-.409.287v-.409c0-.11,0,.177-.077.066s0-.166,0-.254c-.188,0-.155.651-.11,1.226-.132-.265-.177-.221-.221.155,0-.177-.132-.375,0-.442-.077,0-.464-.243-.442.21,0-.11-.1,0-.121,0a.615.615,0,0,0-.331,0v.066c0,.552-.133.133-.254.2v-.055c-.32-.386-.132.2-.431-.254v.342c0,.74-.276-.42-.442-.144l.066.2c-.1.254-.265-.994-.353-1.1s0-.1.055-.144c-.232-.442,0,.442-.21.541,0-.232,0-.607-.066-.651s-.364.773-.519.309a.718.718,0,0,1,0,.508c-.144.066-.32-.718-.464-.144a.627.627,0,0,1,0-.144c-.11.144-.331.232-.42.541,0-1.17-.663.519-.563-.563h-.309v-.11c-.177-.088-.276.166-.375.42v-.232c-.254-.265-.287-.221-.6.276V53.18c-.1.188-.309-.607-.651-.254a.463.463,0,0,1,.066-.155c-.4.342-.519-1.1-.905.132l-.265.265c.243.155-.166.53-.11.762-.121,0-.177-.442,0-.475v.066c.2-.64-.265-.309-.155-.751-.519-.1-.894-.6-1.336-.773l-.11.508-.155-.077c0-.133.077-.409.188-.353,0-.3-.276.177-.32.276-.155-.276.287-.541.232-.574h-.11v.066c-.144.177-.232.386-.353.32s.066-.32,0-.353,0-.055,0,0l-.177-.121-.066.42c-.166.155-.177-.1-.254.375.121-.718-.651-.541-.64-.784-.243.21-.364.155-.5,0,0,.088-.177.519-.287.409.464-.828,0-.486.155-1.1-.11.453-.4-.077-.552.563-.066-.121.155-.32.188-.563-.431.21-.409-.5-.751-.552-.077.1-.121.3-.287.42l.188-.629c-.088,0-.442.574-.309.144a.339.339,0,0,1-.166.254c-.121-.431-.453-.519-.762-.674a.794.794,0,0,1-.431-1.027c-.1.243-.155.221-.221.188s-.2.232-.309.364l.121-.541c-.364.309-.243-.177-.574.121h.121c-.464.3-.7.972-1.17,1.458.519-.342-.309.961.464.464,0,.144-.177.144-.254.276.232-.177.331-.177.353,0h0c.353.21.309.541.574.972l.177-.3a.508.508,0,0,1,0,.287c.386-.342-.2-.188.21-.585-.3.651.541.409.188,1.1.133.088.177-.342.3-.265l-.077.2.177-.2c.066.088,0,.331-.133.486h-.11c0,.276.353.121.353.21L123.053,53c.464,0,.762.541,1.314.331V53.18c.4-.121.133.265.486.3h0c.133-.11.243-.144.309-.088-.155.132,0,.386-.2.53.431-.155.254-.155.7-.607l-.066.254c.166-.188.221-.3.386-.3-.21.155-.066.42-.32.629.1.674.7-.353.519.5.42-.618-.121-.486,0-.6s.32-.464.386-.353-.166.939.1,1.027h-.077c0,.21.276-.166.3.155.21-.386.144.077.353-.442h-.287c.188-.1.53-.685.64-.3a.993.993,0,0,1-.243.276c0,.188.166,0,.177.133-.2.519-.331,0-.618.364,0,.254.409-.287.144.265.353-.7.232.188.585-.32l-.11.32s.155-.177.2-.155l-.221.386c.254-.309.188.4.386.254-.3-.077.055-.42,0-.685.486-.331,0,.905.409.872-.066,0-.155-.254,0-.386a.828.828,0,0,1,.133.431c.287,0,0-.342.21-.508,0,.42.177-.133.331-.232l-.088.331c.254.287.254-.674.464-.353l-.221.442.166-.088-.121.375c.232-.243.265-.166.386,0,0-.254.166-.607.3-.585,0,.21-.121.309.077.3-.077.2-.188.453-.21.121,0,.11-.088.21-.121.309s.254.11.32.121a.122.122,0,0,1,0-.1l.375-.409a.442.442,0,0,1-.088.32c.055,0,.132-.166.221-.188-.077.276-.121.563-.276.663l.342-.243c0,.121.077.353,0,.442.121.2.464-.464.629-.221a.3.3,0,0,1,.1-.132c.177.088.309.453.585.11l.055.508c.2-.088-.088-.64.221-.8s0,.431.088.574c.132-.243.364-.729.519-.309C132.45,56.393,132.406,56.316,132.351,56.349Zm2.208-.088c0,.066-.133.287-.155.088.022-.4.055-.2.121-.088Zm3.2-.95c0,.11-.077,0-.144-.066s.055-.022.11.066Zm7.288-4.693h0c-.166-.055-.11-.022-.033,0Zm.21,0a.243.243,0,0,0-.055-.121v.1s.022.166.022.066Zm-17.745,1.358v.1c-.144.11-.088.033-.033-.055Z",
    transform: "translate(12.599 5.1)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M135.852,55.178a1.1,1.1,0,0,1,0-.188A.243.243,0,0,0,135.852,55.178Z",
    transform: "translate(14.155 5.731)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M130,55.65h0v0Z",
    transform: "translate(13.547 5.8)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M141.794,54.013a.541.541,0,0,1-.144-.133C141.683,53.935,141.727,54.013,141.794,54.013Z",
    transform: "translate(14.761 5.615)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M143.32,49.64v.132h.132C143.508,49.773,143.3,49.662,143.32,49.64Z",
    transform: "translate(14.935 5.173)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M145.141,50.739v-.077l-.1-.121a.133.133,0,0,0,.1.2Z",
    transform: "translate(15.113 5.267)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M144,50.477c.166.232.166.11.2,0C144,50.168,144,50.322,144,50.477Z",
    transform: "translate(15.006 5.242)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M144.16,50.479a.088.088,0,0,1,.055,0C144.138,50.292,144.171,50.413,144.16,50.479Z",
    transform: "translate(15.023 5.25)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M143.013,50.29c.066,0-.166-.331-.088-.232C142.781,49.716,143.013,50.555,143.013,50.29Z",
    transform: "translate(14.889 5.208)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M144.522,51.166l-.232-.276.133.265Z",
    transform: "translate(15.036 5.304)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M143.881,51.271h.132a.144.144,0,0,1,0-.121C143.937,51.194,143.826,51.183,143.881,51.271Z",
    transform: "translate(14.992 5.331)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M144,51.17a.077.077,0,0,0,0-.11A.21.21,0,0,0,144,51.17Z",
    transform: "translate(15.005 5.321)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M144.436,51.314l-.077-.044-.088.033Z",
    transform: "translate(15.034 5.343)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M142.767,51.82l-.077.155c0,.11.11.166.132.1A.258.258,0,0,0,142.767,51.82Z",
    transform: "translate(14.87 5.401)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M143.538,52.44a.915.915,0,0,1-.188-.21l.21.4Z",
    transform: "translate(14.938 5.443)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M143.22,52.68c0,.121,0,.409.121.309C143.3,52.868,143.386,52.713,143.22,52.68Z",
    transform: "translate(14.925 5.49)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M141.212,53.1l.033-.022-.265-.674Z",
    transform: "translate(14.691 5.461)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M140.013,55.133c.221.11-.077-.442.132-.276,0-.177-.177-.133-.177-.287C139.87,54.769,139.793,54.691,140.013,55.133Z",
    transform: "translate(14.576 5.687)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M139.921,54.581V54.46A.287.287,0,0,0,139.921,54.581Z",
    transform: "translate(14.58 5.676)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M122.408,48.677l.044-.177-.133.221Z",
    transform: "translate(12.747 5.055)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M121.943,48.922l.309-.342-.342.265S122.009,48.845,121.943,48.922Z",
    transform: "translate(12.704 5.063)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M133.529,56.445v-.11c0-.121,0-.132-.1-.155Z",
    transform: "translate(13.905 5.855)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M132.08,56.089l.022.011-.022-.42Z",
    transform: "translate(13.764 5.803)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M130.8,56.439s.133-.066.188,0C130.855,56.461,130.855,55.975,130.8,56.439Z",
    transform: "translate(13.631 5.861)",
    fill: "#ffcf05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelbeeLogoRed);
export default __webpack_public_path__ + "static/media/welbee-logo-red.8c4aafa5811cb3285447771efc4f3dc1.svg";
export { ForwardRef as ReactComponent };